import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {reduxForm, Field, stopSubmit, startSubmit} from 'redux-form'
import {Route, Switch, Redirect} from 'react-router-dom'

import BackOfficeParkingPassScreen from '../screens/BackOfficeParkingPassScreen'
import SostaOnlineApiService from '../services/SostaOnlineApiService'

const mapStateToProps = (state) => {
    return {
        state: state.users
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

class BackOfficeParkingPassTableContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            parkingPasses : [],
            count : 0
        }
    }

    componentDidMount() {
        this.setState({loading: true});
        this.fetchUsers();
    }

    onCreateUserClick() {
        this.props.history.push('/backoffice/parkingPasses/create');
    }

    fetchUsers(){
        SostaOnlineApiService.fetchParkingPasses().then((data) => {
            this.setState({
                parkingPasses : data.data
            });
        });
    }

    render() {
        return(
            <BackOfficeParkingPassScreen
                onCreateParkingPassClick={this.onCreateUserClick.bind(this)}
                count = {this.state.count}
                parkingPasses = {this.state.parkingPasses} />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeParkingPassTableContainer);


// WEBPACK FOOTER //
// ./src/containers/BackOfficeParkingPassTableContainer.js